module.exports = __webpack_public_path__ + "img/game6.e2d5894e.png";